import { render } from "./GenericField.vue?vue&type=template&id=2f6e6be2&scoped=true"
import script from "./GenericField.vue?vue&type=script&lang=js"
export * from "./GenericField.vue?vue&type=script&lang=js"

import "./GenericField.vue?vue&type=style&index=0&id=2f6e6be2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6e6be2"]])

export default __exports__